import React from 'react';
import { Printer, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const learn = [
  'Příprava výuky s AI napříč předměty',
  'Hodnocení žáků v době generovaného obsahu',
  'Vedení žáků k odpovědnému používání AI',
  'Prevence: deepfake, kyberšikana, manipulace',
  'Diferenciace – práce s různě pokročilými žáky',
  'Administrativa a komunikace s rodiči',
];

const take = [
  'Bezpečné používání AI ve škole od prvního dne',
  'Konkrétní postupy použitelné hned druhý den',
  'Vlastní materiály z praktických cvičení',
  'Větší jistotu a méně zbytečné administrativy',
];

function LetakContent() {
  return (
    <div style={{
      width: '210mm',
      height: '297mm',
      fontFamily: "'Inter','Helvetica Neue',Arial,sans-serif",
      background: '#fff',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>

      {/* ══ HERO  ~42% výšky ══ */}
      <div style={{
        background: 'linear-gradient(145deg,#042f2e 0%,#0e7068 45%,#0369a1 100%)',
        padding: '32px 36px 28px',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden',
        minHeight: '124mm',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}>
        {/* ring 1 */}
        <div style={{ position:'absolute',right:-10,top:-30,width:190,height:190,borderRadius:'50%',border:'38px solid rgba(255,255,255,0.06)',pointerEvents:'none' }} />
        {/* ring 2 */}
        <div style={{ position:'absolute',right:65,top:90,width:100,height:100,borderRadius:'50%',border:'22px solid rgba(255,255,255,0.04)',pointerEvents:'none' }} />

        {/* TOP: logo + badge */}
        <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',position:'relative' }}>
          <div style={{ display:'flex',alignItems:'center',gap:8 }}>
            <div style={{ width:30,height:30,background:'rgba(255,255,255,0.14)',borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center' }}>
              <span style={{ color:'white',fontWeight:900,fontSize:11,letterSpacing:'-0.5px' }}>AI</span>
            </div>
            <span style={{ color:'rgba(255,255,255,0.88)',fontWeight:600,fontSize:14 }}>AI pro pedagogy</span>
          </div>
          <div style={{ border:'1px solid rgba(255,255,255,0.22)',borderRadius:30,padding:'5px 13px',color:'rgba(255,255,255,0.78)',fontSize:9.5,fontWeight:600,letterSpacing:.3 }}>
            Financovatelné z OP JAK II
          </div>
        </div>

        {/* MIDDLE: headline + stats vpravo */}
        <div style={{ position:'relative', display:'grid', gridTemplateColumns:'1fr 152px', gap:24, alignItems:'center' }}>
          <div>
            <p style={{ color:'rgba(255,255,255,0.45)',fontSize:9,fontWeight:700,letterSpacing:'3.5px',textTransform:'uppercase',marginBottom:10 }}>
              Střední školy
            </p>
            <h1 style={{ color:'white',fontSize:52,fontWeight:900,lineHeight:1.04,letterSpacing:'-2px',marginBottom:16 }}>
              Školení AI<br />pro pedagogy SŠ
            </h1>
            <p style={{ color:'rgba(255,255,255,0.72)',fontSize:14,lineHeight:1.65 }}>
              Dejte pedagogům nástroje, jak s AI pracovat{' '}
              <strong style={{ color:'white',fontWeight:700 }}>bezpečně a efektivně</strong>
              {' '}— od přípravy výuky až po prevenci rizik.
            </p>
          </div>

          {/* Stats karta vpravo */}
          <div style={{
            background:'rgba(255,255,255,0.09)',
            border:'1px solid rgba(255,255,255,0.16)',
            borderRadius:12,
            padding:'18px 16px',
          }}>
            <p style={{ color:'white',fontSize:34,fontWeight:900,lineHeight:1,letterSpacing:'-1px',marginBottom:3,whiteSpace:'nowrap' }}>1&nbsp;500+</p>
            <p style={{ color:'rgba(255,255,255,0.65)',fontSize:10.5,lineHeight:1.45,marginBottom:14 }}>
              pedagogů proškoleno v ČR
            </p>
            <div style={{ height:1,background:'rgba(255,255,255,0.15)',marginBottom:14 }} />
            <p style={{ color:'rgba(255,255,255,0.55)',fontSize:9.5,lineHeight:1.55 }}>
              Realizujeme pro<br />
              <strong style={{ color:'white',fontSize:11 }}>MŠ · ZŠ · SŠ</strong>
            </p>
          </div>
        </div>

        {/* BOTTOM: pills */}
        <div style={{ display:'flex',gap:7,flexWrap:'wrap',position:'relative' }}>
          {['8 vyučovacích hodin','Online & prezenčně','3 400 Kč / účastník'].map((p,i)=>(
            <div key={i} style={{ background:'rgba(255,255,255,0.11)',border:'1px solid rgba(255,255,255,0.18)',borderRadius:5,padding:'6px 12px',color:'white',fontSize:10.5,fontWeight:600 }}>
              {p}
            </div>
          ))}
        </div>
      </div>

      {/* ══ BODY  flex:1 ══ */}
      <div style={{ flex:1,display:'grid',gridTemplateColumns:'1fr 170px',minHeight:0 }}>

        {/* LEFT column */}
        <div style={{
          borderRight:'1px solid #e2e8f0',
          padding:'22px 22px 22px 36px',
          display:'flex',
          flexDirection:'column',
        }}>

          {/* Co se naučí */}
          <div style={{ marginBottom:20 }}>
            <p style={{ fontSize:8,fontWeight:700,color:'#0d9488',letterSpacing:'2px',textTransform:'uppercase',marginBottom:14 }}>
              Co se pedagogové naučí
            </p>
            <div style={{ display:'flex',flexDirection:'column',gap:14 }}>
              {learn.map((t,i)=>(
                <div key={i} style={{ display:'flex',alignItems:'flex-start',gap:10 }}>
                  <div style={{ width:6,height:6,borderRadius:'50%',background:'#0d9488',flexShrink:0,marginTop:7 }} />
                  <span style={{ fontSize:13.5,color:'#1e293b',lineHeight:1.55 }}>{t}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div style={{ height:1,background:'#e2e8f0',marginBottom:20 }} />

          {/* Co si odnesou */}
          <div style={{ marginBottom:16 }}>
            <p style={{ fontSize:8,fontWeight:700,color:'#0369a1',letterSpacing:'2px',textTransform:'uppercase',marginBottom:14 }}>
              Co si účastníci odnesou
            </p>
            <div style={{ display:'flex',flexDirection:'column',gap:14 }}>
              {take.map((t,i)=>(
                <div key={i} style={{ display:'flex',alignItems:'flex-start',gap:10 }}>
                  <div style={{ width:6,height:6,borderRadius:'50%',background:'#0369a1',flexShrink:0,marginTop:7 }} />
                  <span style={{ fontSize:13.5,color:'#1e293b',lineHeight:1.55 }}>{t}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Doplňující box – AI nástroje zdarma */}
          <div style={{
            background:'#f0fdfa',
            border:'1px solid #99f6e4',
            borderRadius:9,
            padding:'13px 15px',
          }}>
            <p style={{ fontSize:9,fontWeight:700,color:'#0f766e',letterSpacing:'1.5px',textTransform:'uppercase',marginBottom:7 }}>
              Žádné skryté náklady
            </p>
            <p style={{ fontSize:12,color:'#134e4a',lineHeight:1.6 }}>
              Školíme <strong>výhradně na AI nástrojích, které jsou zcela zdarma</strong>. Žádné licence, žádné předplatné, žádné skryté poplatky.
            </p>
          </div>

        </div>

        {/* RIGHT column */}
        <div style={{
          background:'#f8fafc',
          padding:'22px 16px',
          display:'flex',
          flexDirection:'column',
          gap:0,
        }}>

          {/* Cena */}
          <div style={{ paddingBottom:16,marginBottom:16,borderBottom:'1px solid #e2e8f0' }}>
            <p style={{ fontSize:7.5,fontWeight:700,color:'#94a3b8',letterSpacing:'2px',textTransform:'uppercase',marginBottom:9 }}>Cena</p>
            <p style={{ fontSize:36,fontWeight:900,color:'#0f172a',letterSpacing:'-2px',lineHeight:1 }}>3 400</p>
            <p style={{ fontSize:11.5,fontWeight:600,color:'#64748b',marginTop:4 }}>Kč / účastník</p>
          </div>

          {/* Rozsah */}
          <div style={{ paddingBottom:16,marginBottom:16,borderBottom:'1px solid #e2e8f0' }}>
            <p style={{ fontSize:7.5,fontWeight:700,color:'#94a3b8',letterSpacing:'2px',textTransform:'uppercase',marginBottom:9 }}>Rozsah</p>
            <p style={{ fontSize:24,fontWeight:800,color:'#0f172a',lineHeight:1,marginBottom:3 }}>8 hodin</p>
            <p style={{ fontSize:10.5,color:'#64748b' }}>2 × 4 hodiny</p>
          </div>

          {/* Forma */}
          <div style={{ paddingBottom:16,marginBottom:16,borderBottom:'1px solid #e2e8f0' }}>
            <p style={{ fontSize:7.5,fontWeight:700,color:'#94a3b8',letterSpacing:'2px',textTransform:'uppercase',marginBottom:9 }}>Forma</p>
            {['Online','Prezenčně'].map((f,i)=>(
              <div key={i} style={{ display:'flex',alignItems:'center',gap:7,marginBottom:i===0?7:0 }}>
                <div style={{ width:6,height:6,borderRadius:'50%',background:'#0d9488' }} />
                <span style={{ fontSize:12.5,fontWeight:600,color:'#0f172a' }}>{f}</span>
              </div>
            ))}
          </div>

          {/* OP JAK II – fills rest */}
          <div style={{
            flex:1,
            background:'linear-gradient(145deg,#0f766e,#0369a1)',
            borderRadius:10,
            padding:'18px 14px',
            textAlign:'center',
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            alignItems:'center',
          }}>
            <p style={{ color:'rgba(255,255,255,0.6)',fontSize:8,letterSpacing:'2px',textTransform:'uppercase',marginBottom:8 }}>
              Financovatelné z
            </p>
            <p style={{ color:'white',fontSize:22,fontWeight:900,letterSpacing:'-0.5px',marginBottom:8 }}>
              OP JAK II
            </p>
            <div style={{ width:32,height:1,background:'rgba(255,255,255,0.2)',marginBottom:10 }} />
            <p style={{ color:'rgba(255,255,255,0.55)',fontSize:9,lineHeight:1.55,textAlign:'center' }}>
              Kurz lze hradit<br />ze šablon OP JAK II
            </p>
          </div>

        </div>
      </div>

      {/* ══ FOOTER ══ */}
      <div style={{
        background:'#0f172a',
        padding:'13px 36px',
        display:'flex',
        alignItems:'center',
        justifyContent:'space-between',
        flexShrink:0,
      }}>
        <div style={{ display:'flex',alignItems:'center',gap:16 }}>
          <span style={{ color:'#5eead4',fontSize:12,fontWeight:700 }}>aipropedagogy.cz</span>
          <span style={{ color:'#1e293b' }}>|</span>
          <span style={{ color:'#94a3b8',fontSize:11 }}>info@aipropedagogy.cz</span>
          <span style={{ color:'#94a3b8',fontSize:11 }}>+420 732 199 307</span>
        </div>
        <a
          href="https://forms.gle/n5o3Ld3dCXix5Nqd7"
          target="_blank"
          rel="noopener noreferrer"
          style={{ background:'#0d9488',borderRadius:5,padding:'7px 14px',textAlign:'center',textDecoration:'none',display:'block' }}
        >
          <p style={{ color:'white',fontSize:9,fontWeight:700,letterSpacing:.5,marginBottom:2 }}>PŘEDREGISTROVAT SE</p>
          <p style={{ color:'rgba(255,255,255,0.6)',fontSize:7.5 }}>forms.gle/n5o3Ld3dCXix5Nqd7</p>
        </a>
      </div>

    </div>
  );
}

export default function LetakSSPage() {
  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .print-only { display: block !important; }
          body { margin: 0; padding: 0; background: white !important; }
          @page { size: A4 portrait; margin: 0; }
        }
        .print-only { display: none; }
      `}</style>

      {/* Top bar */}
      <div className="no-print" style={{
        position:'sticky',top:0,zIndex:50,
        background:'white',borderBottom:'1px solid #e2e8f0',
        padding:'12px 24px',
        display:'flex',alignItems:'center',justifyContent:'space-between',
      }}>
        <Link to="/" style={{ display:'flex',alignItems:'center',gap:6,color:'#0d9488',fontSize:14,textDecoration:'none',fontWeight:500 }}>
          <ArrowLeft size={16} />Zpět na web
        </Link>
        <div style={{ display:'flex',alignItems:'center',gap:12 }}>
          <span style={{ fontSize:12,color:'#94a3b8' }}>A4 náhled (210 × 297 mm)</span>
          <button onClick={()=>window.print()} style={{
            display:'flex',alignItems:'center',gap:8,
            background:'#0d9488',color:'white',border:'none',
            borderRadius:8,padding:'10px 20px',fontSize:14,fontWeight:600,cursor:'pointer',
          }}>
            <Printer size={16} />Uložit jako PDF
          </button>
        </div>
      </div>

      {/* Screen preview */}
      <div className="no-print" style={{
        background:'#7f8ea3',
        minHeight:'calc(100vh - 57px)',
        padding:'40px 24px',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
      }}>
        <div style={{
          fontSize:12,color:'#1e293b',marginBottom:20,
          background:'white',padding:'6px 18px',borderRadius:20,fontWeight:500,
        }}>
          Tisk → <strong>Uložit jako PDF</strong> · Okraje: Žádné · Měřítko: Přizpůsobit stránce
        </div>
        <div style={{ boxShadow:'0 24px 80px rgba(0,0,0,0.35)',display:'inline-block' }}>
          <LetakContent />
        </div>
      </div>

      {/* Print only */}
      <div className="print-only">
        <LetakContent />
      </div>
    </>
  );
}
